<template>
    <transition name="fade">
        <div class="create-design-container">
            <div class="main-container">
                <div class="close-icon" @click="$emit('close-design-pop')">
                    <Icon type="md-close" size="22"></Icon>
                </div>
                <div class="main-title">简单四步 快速完成定制</div>
                <div class="sub-title">简化服装定制的复杂流程  让您轻松快速实现从设计到成品的全过程</div>
                <div class="step-box">
                    <div class="step-title">
                        <div class="step-num">1</div>
                        <div class="step-name">上传设计稿</div>
                    </div>
                    <div class="step-desc">支持多种格式,可上传多张设计图,清晰展示你的创意</div>
                </div>
                <div class="up-body">
                    <Upload
                        type="drag"
                        :action="upload_url"
                        :data="{ dir: 'template' }"
                        multiple
                        :before-upload="onBeforeUpload"
                        :show-upload-list="false"
                    >
                        <div class="upload-box">
                            <img
                                src="../assets/images/icon-upload-blue.png"
                                alt=""
                                class="up-icon"
                            />
                            <div class="up-main-text">拖放文件到此处 或点击上传</div>
                            <div class="up-sub-text">支持 jpg,png,psd,cdr,pdf等格式,可上传多个文件</div>
                        </div>
                    </Upload>
                    <div class="up-file-list">
                        <div class="up-file-item" v-for="(item,index) in form_data.image_list" :key="index">
                            <!-- <img :src="item.raw|default_img" v-viewer /> -->
                            <template v-if="util.test_image(item.raw)">
                                <img :src="item.raw" alt="" style="object-fit:cover;" />
                            </template>
                            <template v-else>
                                <a :href="item.raw" target="_blank">
                                    <img :src="util.get_image_icon(item.raw)" alt="" style="object-fit:cover;" />
                                </a>
                            </template>
                            <img @click="deleteImage(index)" src="../assets/images/icon-close-circle-black.png" alt="" class="remove-icon">
                        </div>
                    </div>
                    <div :class="['bottom',{'single-btn':(!userInfo.have_order)}]">
                        <div class="user-guide">
                             <video @dblclick="toggleFullScreen" :src="guide_url" autoplay muted controls></video>
                            <div class="btn-text">定制教程</div>
                        </div>
                        <div class="btn-box">
                            <div class="advanced-btn" @click="onSave(1)">
                                <img src="@/assets/images/design/icon-edit-red.png" />补充设计资料
                            </div>
                            <Button class="next-btn" @click="onSave(0)">立即下单</Button>
                        </div>
                        <!-- <div class="advanced-btn" @click="onSave(1)">更多设计说明 ></div> -->
                    </div>
                </div>
            </div>
            <popup :show.sync="show_guide" width="1000px" height="800px" @close="show_guide=false">
                <video v-if="show_guide" :src="guide_url" controls autoplay preload muted style="width:100%;height:90%;min-height:90%;margin-top:50px;"></video>
            </popup>
        </div>
    </transition>
</template>
<script>
import { SaveDraft } from '@/api/index';
import Popup from '@/components/Popup.vue';
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
import { driver } from 'driver.js';
import { mapState } from 'vuex';
export default{
    components:{
        Popup
    },
    name:"CreateDesign",
    data(){
        return{
            util: util,
            upload_url: process.uniEnv.BASE_API + "/util/upload-image",
            uploading: false,
            uploadQueue:[],
            debounceTimer: null, // 防抖定时器
            debounceTime: 300, // 防抖时间（毫秒）
            image_list:[],
            is_click:false,
            show_guide:false,
            // guide_url:'https://img.hongli.xingjuju.com/yichuanghub/template/20251208/ac029c91b05f43df804bd72e9112f06bb24fedd4.mp4'
            guide_url:"https://img.hongli.xingjuju.com/yichuanghub/template/20260411/2bba160f6ab66cb46ac2d660fc51c5f2910d1cd7.mp4"
            // navigate_mode:false
        }
    },
    props:{},
    watch:{
        show_guide(news,olds){
            if(news != olds && !news){
                if(!localStorage.getItem('create_pop_guide')){
                    this.startGuide();
                }
            }
        }
    },
    computed:{
        ...mapState({
            form_data:state=>state.design.form_data,
            userInfo:state=>state.userInfo
        })
    },
    async mounted(){
        await this.$store.dispatch('getUser');
        this.$store.commit("design/clear");
        if(!localStorage.getItem('create_pop_guide') && localStorage.getItem('view_guide')){
            this.startGuide();
        }
        if(!localStorage.getItem('view_guide')){
            this.show_guide = true;
            localStorage.setItem('view_guide',1);
        }
    },
    methods:{
        //>Video标签双击全屏切换
        toggleFullScreen() {
            const video = this.$refs.guideVideo;
            if (!video) return;

            // 判断当前是否处于全屏状态
            const isFullscreen = document.fullscreenElement ||
                                document.webkitFullscreenElement ||
                                document.mozFullScreenElement ||
                                document.msFullscreenElement;

            if (isFullscreen) {
                // 退出全屏
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                // 进入全屏
                if (video.requestFullscreen) {
                    video.requestFullscreen();
                } else if (video.webkitRequestFullscreen) {
                    video.webkitRequestFullscreen();
                } else if (video.mozRequestFullScreen) {
                    video.mozRequestFullScreen();
                } else if (video.msRequestFullscreen) {
                    video.msRequestFullscreen();
                }
            }
        },
        startGuide(){
            this.userInfo.have_order = true;
            const guide = driver({
                showProgress:true, //>显示步骤进度
                allowClose:true,   //>禁止点击外部关闭
                nextBtnText:"下一步",
                prevBtnText:"上一步",
                doneBtnText:"完成",
                closeBtnText:"跳过引导",
                steps: [
                    {
                        element: '.upload-box',
                        popover: {
                            title: '上传设计稿',
                            description: '点击此处或拖拽文件到此处进行设计稿上传,支持jpg,png,psd,cdr等格式,可上传多个文件',
                            position: 'right'
                        }
                    },
                    {
                        element: '.next-btn',
                        popover:{
                            title:"快速定制",
                            description: '上传设计稿后点击[下一步],进入下单页面,填写颜色、尺码、数量,添加收货地址,提交订单。',
                            position: 'right'
                        }
                    },
                    {
                        element: '.advanced-btn',
                        popover:{
                            title:"高级定制",
                            description: '点此进入[高级定制],可以选择款式版型、面辅料等信息,满足你更大的设计需求。',
                            position: 'right'
                        }
                    },
                ],
                onDestroyed:async ()=>{
                    //>引导结束,如果存在地址模拟数据,则清空并重新获取地址列表
                    await this.$store.dispatch('getUser');
                    localStorage.setItem('create_pop_guide',1);
                    console.log('aaa')
                }
            })
            guide.drive();
        },
        async onSave(advanced){
            // TODO 保存,获取UUID,跳转新的SUMMARY
            try{
                if (this.is_click) {
                    return;
                }
                this.is_click = true;
                console.log('form_data',this.form_data);
                if(!this.form_data.image_list.length){
                    this.$layer.msg('请上传设计稿');
                    return;
                }
                // return;
                const {data} = await SaveDraft({
                    ...this.form_data,
                    scene: "bc", //bc
                })
                if(!data.uuid){
                    this.$layer.msg('操作失败,请稍后重试');
                    return;
                }
                this.$layer.msg('操作成功,即将跳转定制');
                setTimeout(()=>{
                    if(advanced){
                        this.$router.push({name:'WorkBenchDesign',query:{uuid:data.uuid,from:'draft'}});
                    }else{
                        this.$router.push({name:'QuickDesign',query:{uuid:data.uuid}})
                    }
                    this.$emit('close-design-pop');
                },500);
                console.log('save-data',data);
            }catch(e){
                console.log('e',e);
            }finally{
                this.is_click=false;
            }
        },
        deleteImage(index){
            this.$store.commit('design/arr_remove_one', {key: 'image_list', index})
            let len = this.form_data.image_list.length;
            console.log(111, len)
            if (len === 0) {
                this.main_file = {raw: '', raw_name: ''}
            } else {
                if(typeof this.form_data.image_list[0] === 'object') {
                    this.main_file = this.form_data.image_list[0]
                } else {
                    this.main_file = {
                        raw: this.form_data.image_list[0],
                        raw_name: ''
                    }
                }
            }
        },
        async processAllFiles() {
            const queue = [...this.uploadQueue];
            this.uploadQueue = []; // 清空队列

            console.log(`Startting upload ${queue.length} files...`);

            for (const file of queue) {
                try {
                const url = await uploadFileToOSS(file, "template", false);
                // this.image_list.push({raw:url,raw_name:file.name});
                const object = {raw:url,raw_name:file.name};
                this.$store.commit('design/arr_push_one', {key: 'image_list', value: object})
                console.log('image_list',this.form_data.image_list);
                // console.log('this.image_list',this.image_list);
                } catch (err) {
                    console.log('upfaile--->',err);
                    if(err.code === 'IMAGE_SIZE_LIMIT'){
                        this.$layer.msg(`图片【${file.name}】像素超过限制,最大宽度不能超过4096或者总体像素值不能超过9437184`);
                        return;
                    }

                    this.$layer.msg(`上传失败：${file.name}`);
                }
            }

        },
        onBeforeUpload(file) {
            console.log("file-before", file);
            this.uploading = true;
            // 将文件加入队列
            this.uploadQueue.push(file);

            // 清除旧定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
            this.debounceTimer = setTimeout(() => {
                this.processAllFiles();
            }, this.debounceTime);
            return false;
        },
    }
}
</script>
<style lang="scss" scoped>
 .create-design-container{
    width: 100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position:fixed;
    top:0;
    left:0;
    z-index:102;
    display:flex;
    align-items:center;
    justify-content:center;
    .main-container{
        width:930px;
        // height:727px;
        border-radius:10px;
        background:#ffffff;
        position:relative;
        padding:0 30px;
        .close-icon{
            position:absolute;
            top: 20px;
            right: 25px;
            cursor:pointer;
        }
        .main-title{
            width:100%;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            text-align: center;
            margin-top:31px;
            margin-bottom:13px;
        }
        .sub-title{
            width:100%;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            text-align: center;
            padding-bottom:23px;
            border-bottom:1px solid #ebebeb;
        }
        .step-box{
            width:100%;
            display:flex;
            flex-direction: column;
            margin-top:22px;
            .step-title{
                display:flex;
                align-items:center;
                column-gap:10px;
                .step-num{
                    width:20px;
                    height:20px;
                    background:#1a1a1a;
                    border-radius:5px;
                    line-height:20px;
                    text-align:center;
                    color:#ffffff;
                    font-size:14px;
                }
                .step-name{
                    color:#333333;
                    font-size:18px;
                    font-weight:500;
                }
            }
            .step-desc{
                color: #999999;
                font-size:13px;
            }
        }
        .up-body{
            padding:20px 0;
            .upload-box{
                width:100%;
                max-height:180px;
                display:flex;
                align-items:center;
                justify-content:center;
                flex-direction:column;
                .up-icon {
                    width: 63px;
                    height: 46px;
                    margin-top:36px;
                    margin-bottom:20px;
                    animation: breathe 1s ease-in-out infinite;
                }
                .up-main-text{
                    color:#333333;
                    font-size:16px;
                    margin-bottom:11px;
                }
                .up-sub-text{
                    color:#999999;
                    font-size:12px;
                    margin-bottom:32px;
                }
            }
            .up-file-list{
                width:100%;
                height:auto;
                max-height:220px;
                overflow-y:auto;
                margin-top:30px;
                display:flex;
                align-items:center;
                flex-wrap:wrap;
                gap:10px;
                // margin-bottom:60px;
                // border-bottom:1px solid #ebebeb;
                &::-webkit-scrollbar{
                    display:none;
                }
                .up-file-item{
                    width:100px;
                    height:100px;
                    border-radius:5px;
                    border:1px solid #dbdbdb;
                    background:#f7f7f7;
                    position:relative;
                    img{
                        width:100%;
                        height:100%;
                        border-radius:5px;
                        object-fit:cover;
                    }
                    .remove-icon{
                        width:22px;
                        height:22px;
                        position:absolute;
                        top:5px;
                        right:5px;
                    }
                }
            }
            .bottom{
                width:100%;
                margin-top:100px;
                margin-bottom:30px;
                // border-top:1px solid #ebebeb;
                display:flex;
                align-items:center;
                justify-content:space-between;

                // &.single-btn{
                //     justify-content:flex-start;
                // }
                .btn-box{
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    .next-btn{
                        background: #fe5866;
                        color:#ffffff;
                        border:none;
                        width:200px;
                        height:42px;
                        // margin-top:40px;
                        // margin-bottom:30px;
                    }
                    .advanced-btn{
                        border-radius:5px;
                        border:1px solid #ff5967;
                        color:#ff5967;
                        font-size:14px;
                        cursor:pointer;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:8px;
                        width:200px;
                        height:42px;
                        img{
                            width:22px;
                            height:22px;
                            object-fit:contain;
                        }
                    }
                }
                .user-guide{
                    width:200px;
                    // height:112px;
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    justify-content:center;
                    // cursor:pointer;
                    // img{
                    //     width:100%;
                    //     height:60px;
                    // }
                    video{
                        width:100%;
                        height:112px;
                        border:1px solid #e0e0e0;
                        border-radius:5px;
                        object-fit:cover;
                    }
                    .btn-text{
                        color:#666666;
                        font-size:12px;
                    }
                }
            }
        }

    }
 }
 @keyframes breathe {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
 }
</style>
